<template>
  <el-popover placement="bottom" trigger="hover" popper-class="qs-tips" v-model="value" v-if='!data.isShowMemo&&data.memo'>
    <img :src="data.imgPath" v-show="data.imgPath">
    <div class="qs-tips-label" v-show="data.memo" :class="{'hasImg': data.imgPath}" v-html="data.formatMemo"></div>
    <i class="tips-icon" slot="reference" v-show="data.memo" @mouseenter="value = true" @mouseleave="value = false"></i>
  </el-popover>
</template>

<script>
import { formatStringUrl } from 'utils'
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  watch: {
    data: {
      handler(data) {
        if (data && data.memo) {
          data.formatMemo = formatStringUrl(data.memo)
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      value: false
    }
  }
}
</script>

<style scoped lang="scss">
  .no-margin > .tips-icon {
    margin: 0;
  }
  .tips-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    background: url("../../assets/images/tips-icon-2.png");
    /*margin-left: 9px;*/
    cursor: pointer;
    vertical-align: top;
  }
  img {
    width: 162px;
    height: 102px;
  }
</style>
